import { getData, postData, putData, deleteData } from "../apiClient";

// get vehicle bookings with pagination
export const getVehicleBookingsWithPagination = async ({ page = 1, limit = 10, search = "", from_date = "", to_date = "", date_column = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
            from_date: from_date,
            to_date: to_date,
            date_column: date_column,
        });

        const result = await getData(`/vehicle-booking/bookings?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Vehicle Booking with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// get vehicle booking data with id
export const getVehicleBookingDataWithId = async (id) => {
    try {
        const result = await getData(`/vehicle-booking/booking/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Vehicle Booking data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// create vehicle booking 
export const createVehicleBooking = async ({ data }) => {
    try {
        const result = await postData(`/vehicle-booking/add-booking`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Vehicle Booking add API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// update vehicle booking data
export const updateVehicleBooking = async ({ id, data }) => {
    try {
        const result = await putData(`/vehicle-booking/update-booking/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Vehicle Booking API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// delete vehicle booking
export const deleteVehicleBooking = async ({ id }) => {
    try {
        const result = await deleteData(`/vehicle-booking/delete-booking/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Vehicle Booking API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// Lookups
export const getDriversList = async () => {
    try {
        const result = await getData("/vehicle-booking/drivers");
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Drivers API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

export const getCustomersList = async () => {
    try {
        const result = await getData("/vehicle-booking/booking-customers");
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Customers API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

export const getFlightsList = async () => {
    try {
        const result = await getData("/vehicle-booking/flights");
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Flights API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

export const getVehiclesList = async () => {
    try {
        const result = await getData("/vehicle-management/vehicles?limit=1000");
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Vehicles API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};
